<template>
  <div>
    <ClienteHeader></ClienteHeader>
    <div class="container" style="padding-bottom:60px;" v-if="!loading && contratos && contratos.servicos">
      <div class="row">
        <div class="col-sm-4">
          <ul
            class="sidenav ui-tabs-nav ui-corner-all ui-helper-reset ui-helper-clearfix ui-widget-header"
            role="tablist"
          >
            <li
              role="tab"
              tabindex="0"
              class="ui-tabs-tab ui-corner-top ui-state-default ui-tab "
             
              aria-controls="snav-content1"
              aria-labelledby="ui-id-1"
              aria-selected="true"
              aria-expanded="true"
              style="background:#f2f2f2; font-weight:700;"
            >
              <a
                role="presentation"
                tabindex="-1"
                class="ui-tabs-anchor"
                id="ui-id-1"
              >
              {{contratos.servicos.abreviacao}} - {{contratos.servicos.titulo}}
              </a>
            </li>
            <li
              role="tab"
              tabindex="0"
              class="ui-tabs-tab ui-corner-top ui-state-default ui-tab "
              :class="[$route.meta.etapa_01 ? 'ui-tabs-active ui-state-active': '', contratos.contratacoesEVOEtapas[0].etapa01 ? 'ok':'']"
              aria-controls="snav-content1"
              aria-labelledby="ui-id-1"
              aria-selected="true"
              aria-expanded="true"
            >
              <router-link
                :to="`/paineldegerenciamento/contrato/etapa1/${$route.params.codigoContrato}`"
                role="presentation"
                tabindex="-1"
                class="ui-tabs-anchor"
                id="ui-id-1"
              >
               <i 
               :class="contratos.contratacoesEVOEtapas[0].etapa01 ? 'icon-line-square-check ':'icon-line-alert-octagon'"
               :style="contratos.contratacoesEVOEtapas[0].etapa01 ? 'color:#2ecc71 ':'color:#FF8300'"
               ></i>
                Cadastro da Empresa
                <i class="icon-chevron-right"></i>
              </router-link>
            </li>
            <li
              role="tab"
              tabindex="-1"
              class="ui-tabs-tab ui-corner-top ui-state-default ui-tab"
              :class="[$route.meta.etapa_02 ? 'ui-tabs-active ui-state-active': '', contratos.contratacoesEVOEtapas[0].etapa02 ? 'ok':'']"
              aria-controls="snav-content2"
              aria-labelledby="ui-id-2"
              aria-selected="false"
              aria-expanded="false"
            >
              <router-link
                :to="`/paineldegerenciamento/contrato/etapa2/${$route.params.codigoContrato}`"
                role="presentation"
                tabindex="-1"
                class="ui-tabs-anchor"
                id="ui-id-2"
              >
               <i 
               :class="contratos.contratacoesEVOEtapas[0].etapa02 ? 'icon-line-square-check ':'icon-line-alert-octagon'"
               :style="contratos.contratacoesEVOEtapas[0].etapa02 ? 'color:#2ecc71 ':'color:#FF8300'"
               ></i>
               Cadastro das obrigações
                <i class="icon-chevron-right"></i>
              </router-link>
            </li>
            <li
              role="tab"
              tabindex="-1"
              class="ui-tabs-tab ui-corner-top ui-state-default ui-tab"
              :class="[$route.meta.etapa_03 ? 'ui-tabs-active ui-state-active': '', contratos.contratacoesEVOEtapas[0].etapa03 ? 'ok':'']"
              aria-controls="snav-content3"
              aria-labelledby="ui-id-3"
              aria-selected="false"
              aria-expanded="false"
            >
              <router-link
                :to="`/paineldegerenciamento/contrato/etapa3/${$route.params.codigoContrato}`"
                role="presentation"
                tabindex="-1"
                class="ui-tabs-anchor"
                id="ui-id-3"
              >
               <i 
               :class="contratos.contratacoesEVOEtapas[0].etapa03 ? 'icon-line-square-check ':'icon-line-alert-octagon'"
               :style="contratos.contratacoesEVOEtapas[0].etapa03 ? 'color:#2ecc71 ':'color:#FF8300'"
               ></i>
               Cadastro da edificação
                <i class="icon-chevron-right"></i>
              </router-link>
            </li>
            <li
              role="tab"
              tabindex="-1"
              class="ui-tabs-tab ui-corner-top ui-state-default ui-tab"
              :class="[$route.meta.etapa_04 ? 'ui-tabs-active ui-state-active': '', contratos.contratacoesEVOEtapas[0].etapa04 ? 'ok':'']"
              aria-controls="snav-content3"
              aria-labelledby="ui-id-3"
              aria-selected="false"
              aria-expanded="false"
            >
              <router-link
                :to="`/paineldegerenciamento/contrato/etapa4/${$route.params.codigoContrato}`"
                role="presentation"
                tabindex="-1"
                class="ui-tabs-anchor"
                id="ui-id-3"
              >
               <i 
               :class="contratos.contratacoesEVOEtapas[0].etapa04 ? 'icon-line-square-check ':'icon-line-alert-octagon'"
               :style="contratos.contratacoesEVOEtapas[0].etapa04 ? 'color:#2ecc71 ':'color:#FF8300'"
               ></i>
               Cadastro da estacionamento
                <i class="icon-chevron-right"></i>
              </router-link>
            </li>
            <li
              role="tab"
              tabindex="-1"
              class="ui-tabs-tab ui-corner-top ui-state-default ui-tab"
              :class="[$route.meta.etapa_05 ? 'ui-tabs-active ui-state-active': '', contratos.contratacoesEVOEtapas[0].etapa05 ? 'ok':'']"
              aria-controls="snav-content3"
              aria-labelledby="ui-id-3"
              aria-selected="false"
              aria-expanded="false"
            >
              <router-link
                :to="`/paineldegerenciamento/contrato/etapa5/${$route.params.codigoContrato}`"
                role="presentation"
                tabindex="-1"
                class="ui-tabs-anchor"
                id="ui-id-3"
              >
               <i 
               :class="contratos.contratacoesEVOEtapas[0].etapa05 ? 'icon-line-square-check ':'icon-line-alert-octagon'"
               :style="contratos.contratacoesEVOEtapas[0].etapa05 ? 'color:#2ecc71 ':'color:#FF8300'"
               ></i>
               Cadastro de mão de obras
                <i class="icon-chevron-right"></i>
              </router-link>
            </li>

            <li
              role="tab"
              tabindex="-1"
              class="ui-tabs-tab ui-corner-top ui-state-default ui-tab"
              :class="[$route.meta.etapa_06 ? 'ui-tabs-active ui-state-active': '', contratos.contratacoesEVOEtapas[0].etapa06 ? 'ok':'']"
              aria-controls="snav-content3"
              aria-labelledby="ui-id-3"
              aria-selected="false"
              aria-expanded="false"
            >
              <router-link
                :to="`/paineldegerenciamento/contrato/etapa6/${$route.params.codigoContrato}`"
                role="presentation"
                tabindex="-1"
                class="ui-tabs-anchor"
                id="ui-id-3"
              >
               <i 
               :class="contratos.contratacoesEVOEtapas[0].etapa06 ? 'icon-line-square-check ':'icon-line-alert-octagon'"
               :style="contratos.contratacoesEVOEtapas[0].etapa06 ? 'color:#2ecc71 ':'color:#FF8300'"
               ></i>
               Cadastro de custos fixos
                <i class="icon-chevron-right"></i>
              </router-link>
            </li>
            <li
              role="tab"
              tabindex="-1"
              class="ui-tabs-tab ui-corner-top ui-state-default ui-tab"
              :class="[$route.meta.etapa_07 ? 'ui-tabs-active ui-state-active': '', contratos.contratacoesEVOEtapas[0].etapa07 ? 'ok':'']"
              aria-controls="snav-content3"
              aria-labelledby="ui-id-3"
              aria-selected="false"
              aria-expanded="false"
            >
              <router-link
                :to="`/paineldegerenciamento/contrato/etapa7/${$route.params.codigoContrato}`"
                role="presentation"
                tabindex="-1"
                class="ui-tabs-anchor"
                id="ui-id-3"
              >
               <i 
               :class="contratos.contratacoesEVOEtapas[0].etapa07 ? 'icon-line-square-check ':'icon-line-alert-octagon'"
               :style="contratos.contratacoesEVOEtapas[0].etapa07 ? 'color:#2ecc71 ':'color:#FF8300'"
               ></i>
               Cadastro de custos variáveis
                <i class="icon-chevron-right"></i>
              </router-link>
            </li>              
            <li
              role="tab"
              tabindex="-1"
              class="ui-tabs-tab ui-corner-top ui-state-default ui-tab"
              :class="[$route.meta.etapa_08 ? 'ui-tabs-active ui-state-active': '', contratos.contratacoesEVOEtapas[0].etapa08 ? 'ok':'']"
              aria-controls="snav-content3"
              aria-labelledby="ui-id-3"
              aria-selected="false"
              aria-expanded="false"
            >
              <router-link
                :to="`/paineldegerenciamento/contrato/etapa8/${$route.params.codigoContrato}`"
                role="presentation"
                tabindex="-1"
                class="ui-tabs-anchor"
                id="ui-id-3"
              >
               <i 
               :class="contratos.contratacoesEVOEtapas[0].etapa08 ? 'icon-line-square-check ':'icon-line-alert-octagon'"
               :style="contratos.contratacoesEVOEtapas[0].etapa08 ? 'color:#2ecc71 ':'color:#FF8300'"
               ></i>
               Cadastro de insumos de produção
                <i class="icon-chevron-right"></i>
              </router-link>
            </li>            
            <li
              role="tab"
              tabindex="-1"
              class="ui-tabs-tab ui-corner-top ui-state-default ui-tab"
              :class="[$route.meta.etapa_09? 'ui-tabs-active ui-state-active': '', contratos.contratacoesEVOEtapas[0].etapa09 ? 'ok':'']"
              aria-controls="snav-content3"
              aria-labelledby="ui-id-3"
              aria-selected="false"
              aria-expanded="false"
            >
              <router-link
                :to="`/paineldegerenciamento/contrato/etapa9/${$route.params.codigoContrato}`"
                role="presentation"
                tabindex="-1"
                class="ui-tabs-anchor"
                id="ui-id-3"
              >
               <i 
               :class="contratos.contratacoesEVOEtapas[0].etapa09 ? 'icon-line-square-check ':'icon-line-alert-octagon'"
               :style="contratos.contratacoesEVOEtapas[0].etapa09 ? 'color:#2ecc71 ':'color:#FF8300'"
               ></i>
              Cadastro de ferramentas
                <i class="icon-chevron-right"></i>
              </router-link>
            </li>            
            <li
              role="tab"
              tabindex="-1"
              class="ui-tabs-tab ui-corner-top ui-state-default ui-tab"
              :class="[$route.meta.etapa_10 ? 'ui-tabs-active ui-state-active': '', contratos.contratacoesEVOEtapas[0].etapa10 ? 'ok':'']"
              aria-controls="snav-content3"
              aria-labelledby="ui-id-3"
              aria-selected="false"
              aria-expanded="false"
            >
              <router-link
                :to="`/paineldegerenciamento/contrato/etapa10/${$route.params.codigoContrato}`"
                role="presentation"
                tabindex="-1"
                class="ui-tabs-anchor"
                id="ui-id-3"
              >
               <i 
               :class="contratos.contratacoesEVOEtapas[0].etapa10 ? 'icon-line-square-check ':'icon-line-alert-octagon'"
               :style="contratos.contratacoesEVOEtapas[0].etapa10 ? 'color:#2ecc71 ':'color:#FF8300'"
               ></i>
               Ativo fixo
                <i class="icon-chevron-right"></i>
              </router-link>
            </li>            
            <li
              role="tab"
              tabindex="-1"
              class="ui-tabs-tab ui-corner-top ui-state-default ui-tab"
              :class="[$route.meta.etapa_11 ? 'ui-tabs-active ui-state-active': '', contratos.contratacoesEVOEtapas[0].etapa11 ? 'ok':'']"
              aria-controls="snav-content3"
              aria-labelledby="ui-id-3"
              aria-selected="false"
              aria-expanded="false"
            >
              <router-link
                :to="`/paineldegerenciamento/contrato/etapa11/${$route.params.codigoContrato}`"
                role="presentation"
                tabindex="-1"
                class="ui-tabs-anchor"
                id="ui-id-3"
              >
               <i 
               :class="contratos.contratacoesEVOEtapas[0].etapa11 ? 'icon-line-square-check ':'icon-line-alert-octagon'"
               :style="contratos.contratacoesEVOEtapas[0].etapa11 ? 'color:#2ecc71 ':'color:#FF8300'"
               ></i>
               Cadastro de veículos da empresa
                <i class="icon-chevron-right"></i>
              </router-link>
            </li>            
            <li
              role="tab"
              tabindex="-1"
              class="ui-tabs-tab ui-corner-top ui-state-default ui-tab"
              :class="[$route.meta.etapa_12 ? 'ui-tabs-active ui-state-active': '', contratos.contratacoesEVOEtapas[0].etapa12 ? 'ok':'']"
              aria-controls="snav-content3"
              aria-labelledby="ui-id-3"
              aria-selected="false"
              aria-expanded="false"
            >
              <router-link
                :to="`/paineldegerenciamento/contrato/etapa12/${$route.params.codigoContrato}`"
                role="presentation"
                tabindex="-1"
                class="ui-tabs-anchor"
                id="ui-id-3"
                @click="fnContrato()"
              >
              <i
               :class="contratos.contratacoesEVOEtapas[0].etapa12 ? 'icon-line-square-check ':'icon-line-alert-octagon'"
               :style="contratos.contratacoesEVOEtapas[0].etapa12 ? 'color:#2ecc71 ':'color:#FF8300'"
               >
               </i>
               Cadastro da produção
                <i class="icon-chevron-right"></i>
              </router-link>
            </li>               
            <li
            v-if="contratos.etaparealizadas >= 12"
              role="tab"
              tabindex="-1"
              class="ui-tabs-tab ui-corner-top ui-state-default ui-tab"
              :class="[$route.meta.etapa_13 ? 'ui-tabs-active ui-state-active': '', contratos.contratacoesEVOEtapas[0].etapa13 ? 'ok':'']"
              aria-controls="snav-content3"
              aria-labelledby="ui-id-3"
              aria-selected="false"
              aria-expanded="false"
            >
              <router-link
                :to="`/paineldegerenciamento/contrato/etapa13/${$route.params.codigoContrato}`"
                role="presentation"
                tabindex="-1"
                class="ui-tabs-anchor aprovat"
                id="ui-id-3"
                style="background-color:#2C3E50 !important"
                @click="fnContrato()"
              >
              <i
               :class="contratos.contratacoesEVOEtapas[0].etapa13 ? 'icon-line-square-check ':'icon-line-alert-octagon'"
               :style="contratos.contratacoesEVOEtapas[0].etapa13 ? 'color:#2ecc71 ':'color:#FF8300'"
               >
               </i>
               Envio/Status
                <i class="icon-chevron-right"></i>
              </router-link>
            </li>            
          </ul>
        </div>
        <router-view class="col-sm-8"></router-view>
      </div>
    </div>
  </div>
</template>
<script>
import ClienteHeader from "../../_include/Cabecalho";

export default {
  components: { ClienteHeader },
  data() {
    return {
      contratos:{},
      loading: false
    }
  },
  mounted() {
     this.$vs.loading()
     setTimeout( ()=> {
        this.$vs.loading.close()
      }, 2000);
      setInterval(()=>{
        this.fnContrato()

      },100000)
      this.fnContrato()
  },
  methods: {
              fnContrato(){
                if (this.$route.params.codigoContrato != undefined)
                {
                 this.$http.get(`contratacao/lista/${this.$route.params.codigoContrato}`)
                .then(res=>{
                    this.contratos = res.data
                    var etapa = 1;
                    var c = 0;
                    if(!res.data.contratacoesEVOEtapas[0].etapa13){etapa = 13}
                    if(!res.data.contratacoesEVOEtapas[0].etapa12){etapa = 12}
                    if(!res.data.contratacoesEVOEtapas[0].etapa11){etapa = 11}
                    if(!res.data.contratacoesEVOEtapas[0].etapa10){etapa = 10}
                    if(!res.data.contratacoesEVOEtapas[0].etapa09){etapa = 9}
                    if(!res.data.contratacoesEVOEtapas[0].etapa08){etapa = 8}
                    if(!res.data.contratacoesEVOEtapas[0].etapa07){etapa = 7}
                    if(!res.data.contratacoesEVOEtapas[0].etapa06){etapa = 6}
                    if(!res.data.contratacoesEVOEtapas[0].etapa05){etapa = 5}
                    if(!res.data.contratacoesEVOEtapas[0].etapa04){etapa = 4}
                    if(!res.data.contratacoesEVOEtapas[0].etapa03){etapa = 3}
                    if(!res.data.contratacoesEVOEtapas[0].etapa02){etapa = 2}
                    if(!res.data.contratacoesEVOEtapas[0].etapa01){etapa = 1}
                    if(res.data.contratacoesEVOEtapas[0].etapa13){c++}
                    if(res.data.contratacoesEVOEtapas[0].etapa12){c++}
                    if(res.data.contratacoesEVOEtapas[0].etapa11){c++}
                    if(res.data.contratacoesEVOEtapas[0].etapa10){c++}
                    if(res.data.contratacoesEVOEtapas[0].etapa09){c++}
                    if(res.data.contratacoesEVOEtapas[0].etapa08){c++}
                    if(res.data.contratacoesEVOEtapas[0].etapa07){c++}
                    if(res.data.contratacoesEVOEtapas[0].etapa06){c++}
                    if(res.data.contratacoesEVOEtapas[0].etapa05){c++}
                    if(res.data.contratacoesEVOEtapas[0].etapa04){c++}
                    if(res.data.contratacoesEVOEtapas[0].etapa03){c++}
                    if(res.data.contratacoesEVOEtapas[0].etapa02){c++}
                    if(res.data.contratacoesEVOEtapas[0].etapa01){c++}
                    this.contratos.etapa = etapa
                    this.contratos.etaparealizadas = c
                    this.loading =false

                })
                .catch(()=>{}).finally()
               }

            },
  },
};
</script>

<style lang="scss" scoped>
.areaconteundo {
  display: flex;
}
.router-link-active,.aprovat{
     color:#fff !important;
 i{
    color:#fff !important;
  }
}
.sidenav li a{
  padding-left: 30px !important;
}
.sidenav{
   counter-reset: my-sec-counter;
   li{
     position: relative;
     &.ok{
      &::before{
        background: #8fc4a5 !important;
        color: #fff;
      }
      &:nth-child(odd){
        &::before{
           background: #87bd9d !important;
        }
       
      }

     }
       &:nth-child(odd){
        &::before{
           background: #fddcbc;
        }
       
      }
    
   }
   
   li:not(:first-child)::before{
    counter-increment: my-sec-counter;
    content: counter(my-sec-counter);
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top:0;
    z-index: 9;
    width: 25px;
    background: #f2c496;
    min-height: 49px;
    font-size: 12px;
    border-bottom:1px solid #fff !important;
   }
}
</style>